var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "banner-display",
      class: [_vm.interactionState],
      on: {
        mouseover: function ($event) {
          _vm.hover = true
        },
        mouseleave: function ($event) {
          _vm.hover = false
        },
      },
    },
    [
      _vm._t("background"),
      _vm._v(" "),
      _c("div", { staticClass: "banner-display-inner" }, [
        _c("div", { staticClass: "banner-content-container" }, [
          _c(
            "div",
            {
              staticClass: "banner-content",
              class: [
                _vm.displayBannerVerticalPosition,
                _vm.displayBannerHorizontalPosition,
              ],
            },
            [
              _c(
                "div",
                {
                  staticClass: "banner-content-inner",
                  class: _vm.content.BannerTextAlignment,
                },
                [
                  _c("div", { staticClass: "banner-content-text" }, [
                    _vm.content.subtitle
                      ? _c("div", { staticClass: "banner-sub-title" }, [
                          _c("h3", [_vm._v(_vm._s(_vm.content.subtitle))]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.content.title
                      ? _c("div", { staticClass: "banner-title" }, [
                          _c("h1", {
                            domProps: { innerHTML: _vm._s(_vm.content.title) },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.content.description
                      ? _c("div", {
                          staticClass: "banner-description",
                          domProps: {
                            innerHTML: _vm._s(_vm.content.description),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.titledActions
                      ? _c(
                          "div",
                          {
                            staticClass: "banner-actions",
                            class: _vm.moreThanOne(_vm.content.actions),
                          },
                          _vm._l(_vm.content.actions, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "banner-action-item" },
                              [
                                item.linkTitle && item.linkUrl
                                  ? _c("HighlightButton", {
                                      attrs: {
                                        "url-new-window": item.target,
                                        "button-type": "square",
                                        "button-size": item.buttonSize,
                                        "button-style": item.buttonStyle,
                                        url: item.linkUrl,
                                        title: item.linkTitle,
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._t("graphic"),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.content.fullBannerLink && _vm.content.fullBannerLink.linkUrl
        ? [
            _c("generic-link", {
              staticClass: "overlay-link",
              attrs: {
                href: _vm.content.fullBannerLink.linkUrl,
                target: _vm.targetNewWindow,
                rel: _vm.buttonRel,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }